export default {
	init() {
		$('a[href=#gatedModal]').click(function(e){

			e.preventDefault();
			$('#gatedModal').modal('show')
		});
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/resources.js